export default {
  'home.hero.title': '爱情岛视频',
  'home.hero.subtitle': '高清在线观看入口',
  'home.hero.description': '提供最新爱情岛视频资源，支持免费流畅观看，无需下载，多线路切换，让您随时随地畅享精彩爱情岛视频内容',
  'home.hero.cta': '开始观看',
  'home.hero.secondary': '了解更多',
  'home.featured.title': '精选推荐',
  'home.featured.subtitle': '编辑精选，口碑佳作',
  'home.latest.title': '最新更新',
  'home.latest.subtitle': '实时更新，第一时间观看',
  'home.categories.title': '视频分类',
  'home.categories.subtitle': '多种分类，满足不同喜好',
  'home.faq.title': '常见问题',
  'home.faq.subtitle': '关于爱情岛视频的常见疑问解答',
  'home.stats.videos': '视频资源',
  'home.stats.users': '活跃用户',
  'home.stats.rating': '用户好评率',
  'home.stats.updates': '每周更新',
};